import { useLang } from "@/lib/i18n";
import fr from "@/locales/fr.json";
import en from "@/locales/en.json";
import de from "@/locales/de.json";
import es from "@/locales/es.json";
import it from "@/locales/it.json";
import nl from "@/locales/nl.json";

const CATALOG = { fr, en, de, es, it, nl };

/**
 * Hook fournissant le contenu long (FAQ, Legal, Mentions, Reviews) traduit.
 * Fallback : lang courant → EN → FR.
 */
export function useContent() {
  const { lang } = useLang();
  const primary = CATALOG[lang] || CATALOG.en;
  return {
    lang,
    refs: primary.refs || CATALOG.en.refs,
    faq: primary.faq || CATALOG.en.faq,
    mentions: primary.mentions || CATALOG.en.mentions,
    legal: primary.legal || CATALOG.en.legal,
  };
}
